<template>
  <nuttrema-layout-form-standard
    :edit="edit"
    :saveError="PersonSettingsMeasurementsGeneral.saveError">

    <template slot="center">

      <!-- <slot name="attention"></slot> -->

      <el-form
         label-width="20em"
        :rules="rules"
        :ref="formRef"
        :model="validationData">

        <section v-for="section in PersonSettingsMeasurementsGeneral.data" :key="section.id">
          <h4 class="section-title">{{ section.name }}</h4>
          <div class="section-items">
            <template v-for="settingType in section.MeasurementSettingTypes">
              <el-form-item
                :prop="settingType.code"
                :label="settingType.name"
                :key="settingType.id">
                <component
                   v-bind:is="componentName(settingType.input_type)"
                  :id="settingType.id"
                  :code="settingType.code"
                  :options="settingType.MeasurementSettingTypeOptions"
                  :description="settingType.description"
                  :input="settingType.MeasurementSetting"
                  :value.sync="formData"
                  :disabled="!edit"
                  :clearable="false"
                  :validation="settingType.validation"
                  :expressedInUnit="settingType.expressed_in_unit"
                  :dependsOn="validationData[settingType.depends_on]"
                  @set:value="setValueEvent">
                </component>
              </el-form-item>
            </template>
          </div>
        </section>

        <section>
          <p class="section-help">
            <span v-html="_markdown.renderInline( $t('label.evolution_settings_help') )"></span>
            <router-link
              tag="a" :to="{ name: 'participant-profile' }">
              {{ $t('label.personal_information') }}
            </router-link>
          </p>
        </section>
      </el-form>

    </template>
    <!-- end ~ slot - center -->

    <template slot="footer">
      <nav class="footer-row">
        <el-button type="primary" size="small" :loading="isSaving" :disabled="!isDataChanged" @click="submitForm">{{ $t('label.save') }}</el-button>

        <el-button type="text" size="small" @click="cancelChanges" >
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import Vue from 'vue';
import { isEmpty, has, isNil, pickBy, each, get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import FormInputSelect from './evolution-settings-form-input/cmpt-form-input-select';
import FormInputSimple from './evolution-settings-form-input/cmpt-form-input-simple';
import FormInputSimpleWithSuggestions from './evolution-settings-form-input/cmpt-form-input-simple-with-suggestions';

export default {
  name: 'form-evolution-settings-general',
  mixins: [FormStandardBehavior],
  props: {
    PersonDetails: {
      required: true,
      default: null,
    },
    PersonSettingsMeasurementsGeneral: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    FormInputSelect,
    FormInputSimple,
    NuttremaLayoutFormStandard,
    FormInputSimpleWithSuggestions,
  },
  data() {
    return {
      formData: {},
      validationData: {},
      rules: {},
      rulesDerived: {},
      help: {
        height: [
          this.$t('label.evolution_settings_general_height_help'),
        ],
        weight: [
          this.$t('label.evolution_settings_general_weight_help'),
        ],
        activity_factor: [
          this.$t('label.evolution_settings_general_activity_factor_1_help'),
          this.$t('label.evolution_settings_general_activity_factor_2_help'),
        ],
        ideal_body_weight: [
          this.$t('label.evolution_settings_general_ideal_body_weight_help'),
        ],
        optimal_fat: [
          this.$t('label.evolution_settings_general_optimal_fat_help'),
        ],
      },
    };
  },
  methods: {
    isEmpty(value) {
      return isEmpty(value);
    },
    componentName(value) {
      const name = value.replace(/_/g, '-');
      return `form-input-${name}`;
    },
    setValueEvent(params) {
      console.log('setValueEvent', params.data);
      Vue.set(this.formData, params.code, params.data);
      if (has(params, 'data.value')) Vue.set(this.validationData, params.code, params.data.value);
      if (has(params, 'data.value_text')) Vue.set(this.validationData, params.code, params.data.value_text);
      // this.originalData = cloneDeep(this.formData);
    },
    isEvolutionConfigured() {
      return this.ParticipantDetails ? this.ParticipantDetails.data.evolution_configured : false;
    },
    prepareRule(validation, calculated, code) {
      const rule = {};
      if (!isEmpty(validation)) {
        if (has(validation, 'type') && validation.type === 'number') {
          Vue.set(rule, 'type', 'number');
        }

        if (has(validation, 'min')) {
          Vue.set(rule, 'min', validation.min);
        }

        if (has(validation, 'max')) {
          Vue.set(rule, 'max', validation.max);
        }

        if (has(validation, 'allow_empty') && !validation.allow_empty) {
          Vue.set(rule, 'required', true);
          Vue.set(rule, 'message', this.formatValidationMessage('validation.required', `label.${code}`, true));
        }

        if (calculated) {
          Vue.set(rule, 'min', -100000000);
          Vue.set(rule, 'required', false);
        }
      }
      return rule;
    },
    setRule(measurementSettingType) {
      const rule = this.prepareRule(measurementSettingType.validation, measurementSettingType.calculated, measurementSettingType.code);
      Vue.set(this.rules, measurementSettingType.code, rule);
    },
    checkIsCalculate() {
      return false;
    },
    checkIsCustomValue(code, dependent) {
      console.log('checkIsCustomValue', code, dependent);
      if (dependent) {
        this.$nextTick(() => {
          const rule = this.rules[dependent];
          if (this.formData[code] === 'custom' && rule) {
            Vue.set(rule[0], 'min', 1);
            Vue.set(rule[0], 'required', true);
          } else {
            Vue.set(rule[0], 'min', 0);
            Vue.set(rule[0], 'required', false);
          }
        });
      }
    },
    getFormData() {
      const payload = {
        measurement_settings: pickBy(this.formData, settingType => !isNil(settingType.value) || !isNil(settingType.value_text)),
      };
      return payload;
    },
    setFormData() {
      each(get(this.PersonSettingsMeasurementsGeneral, 'data', []), (section) => {
        console.log('section', section.code);
        each(section.MeasurementSettingTypes, (measurementSettingType) => {
          console.log('measurementSettingType', measurementSettingType.code);
          this.setRule(measurementSettingType);
        });
      });
    },
  },
  created() {
    this.stateData = this.PersonSettingsMeasurementsGeneral;
    this.formRef = 'form-evolution-settings-general';
    this.setFormData();
  },
};
</script>

<!--   computed: {
    // isDependent() {
    //   const dependent = {};
    //   each(this.participantSettingsMeasurementsGeneral, (section) => {
    //     each(section.MeasurementSettingTypes, (measurementSettingType) => {
    //       const dependsOn = measurementSettingType.depends_on ? this.validationData[measurementSettingType.depends_on] !== 'custom' : false;
    //       Vue.set(dependent, measurementSettingType.code, dependsOn);
    //     });
    //   });
    //   return dependent;
    // },
    // measurement_settings() {
    //   const values = {};
    //   each(this.participantSettingsMeasurementsGeneral, (setting) => {
    //     each(setting.MeasurementSettingTypes.primitive, (primitive) => {
    //       const setting = this.prepareAndSetValue(primitive);
    //       Vue.set(values, primitive.code, setting);
    //     });
    //     each(setting.MeasurementSettingTypes.derived, (derived) => {
    //       const setting = this.prepareAndSetValue(derived);
    //       Vue.set(values, derived.code, setting);
    //     });
    //   });
    //   return values;
    // },
  },
  watch: {
    // participantSettingsMeasurementsGeneral(newVal) {
    //   if (!isEmpty(newVal)) {
    //     this.setValues(newVal);
    //     this.originalData = cloneDeep(this.formData);
    //   }
    // },
  }, -->



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/settings/form-evolution-settings-general.vue